/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class LocalAtendimento {
  constructor () {
    this.local_atendimento_id = uuidV4()
    this.descricao = ''
    this.imagens = []
  }
}
